import React from 'react';
import { Accordion } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is imported
import '../../styles/transport.css'; // Import specific CSS for styling
import '../../styles/Fonts.css'; // Import font styling if needed

const faqData = [
  {
    question: 'What types of transportation services do you offer?',
    answer: (
      <p className='poppins-regular text-start'>
        We offer a comprehensive range of transportation services, including road, rail, air, and sea options. 
        Our services can be customized based on the size of your shipment, your destination, and the speed at which you require delivery.
      </p>
    ),
  },
  {
    question: 'Are there any shipment restrictions or limitations?',
    answer: (
      <p className='poppins-regular text-start'>
        Yes, there are certain restrictions and limitations on shipments due to local or international regulations. 
        We recommend contacting our support team for detailed information regarding any specific restrictions that may apply to your shipment.
      </p>
    ),
  },
  {
    question: 'Do you handle international shipments?',
    answer: (
      <p className='poppins-regular text-start'>
        Yes, we manage international shipments and ensure that all customs regulations are strictly adhered to. 
        Our team is experienced in handling the complexities of international shipping, ensuring a smooth and hassle-free process.
      </p>
    ),
  },
  {
    question: 'How can I track my shipment?',
    answer: (
      <p className='poppins-regular text-start'>
        You can track your shipment in real-time using our advanced tracking system, which is accessible through our website. 
        Simply enter your tracking number, and you will receive up-to-date information about your shipment’s status and estimated delivery time.
      </p>
    ),
  },
];

const TransportFAQ = () => {
  return (
    <section id="faq" className="transport-faq-section">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-badge">HAVE QUESTIONS?</div>
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-description">
            Get answers to common questions about our transport services and processes.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-8">
            <Accordion>
              {faqData.map((faq, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header>
                    <h5 className="mb-0">{faq.question}</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                    {faq.answer}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransportFAQ;
